// extracted by mini-css-extract-plugin
export default {"container":"MyContainer_container__XlGh4","table":"MyContainer_table__M5maE","table_body":"MyContainer_table_body__UWcVZ","area_container":"MyContainer_area_container__RQog4"};